<script setup lang="ts">
import { computed } from 'vue';
import AppModal from './AppModal.vue';
import AppButton from './AppButton.vue';
import { useConfirm } from '../composables/useConfirm';

const { request, accept, cancel } = useConfirm();
const open = computed(() => request.value !== null);
</script>

<template>
  <AppModal :open="open" :title="request?.title ?? 'Please confirm'" @close="cancel">
    <p class="confirm__message">{{ request?.message }}</p>
    <template #actions>
      <AppButton variant="ghost" @click="cancel">{{ request?.cancelLabel ?? 'Cancel' }}</AppButton>
      <AppButton :variant="request?.tone === 'danger' ? 'danger' : 'primary'" @click="accept">
        {{ request?.confirmLabel ?? 'Confirm' }}
      </AppButton>
    </template>
  </AppModal>
</template>

<style scoped>
.confirm__message {
  color: var(--text-secondary);
  line-height: 1.5;
}
</style>
